import React from 'react';
import SalesDetailPage from './SalesDetailPage';
import { SORT_TYPES } from '../constants/sortTypes';
import {
  buildMemberFilterGroups,
  buildMemberApiFilters,
  memberColumns,
  memberReportBaseConfig,
  renderMemberCell,
} from '../constants/membershipReportShared';
import { currencyFormatter } from '../utils/reportingUtils';

const DAYS_FILTER = { id: 'failing_days', label: 'Days Failing' };

const FAILED_PAYMENT_COLUMNS = memberColumns([
  { id: 'failing_since', label: 'Failing Since', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'last_paid_at', label: 'Last Paid', defaultVisible: true, sortable: true, sortType: 'date' },
]);

const FAILED_PAYMENTS_CONFIG = {
  ...memberReportBaseConfig({
    slug: 'failed-payments',
    title: 'Failed Payments',
    sidebarKey: 'memberships_failed_payments',
    localStorageName: 'reportingMembershipsFailedPaymentsColumns',
  }),
  pageSubtitle: 'Members whose renewal charge failed. Past due members are still being retried; unpaid members have run out of retries.',
  columns: FAILED_PAYMENT_COLUMNS.columns,
  sortTypes: SORT_TYPES,
  getDefaultVisibleColumns: FAILED_PAYMENT_COLUMNS.getDefaultVisibleColumns,
  getDefaultHiddenColumns: FAILED_PAYMENT_COLUMNS.getDefaultHiddenColumns,
  defaultSortRules: [{ field: 'failing_since', direction: 'asc' }],
  emptyMessage: 'No failed membership payments.',

  buildFilterGroups: (venueOwnerships) => buildMemberFilterGroups({
    venueOwnerships, statuses: ['past_due', 'unpaid'], daysFilter: DAYS_FILTER,
  }),
  buildDetailApiFilters: buildMemberApiFilters(DAYS_FILTER.id),

  buildKpiCards: (current) => [
    { label: 'Failed Payments', value: (current.failed_payments || 0).toLocaleString() },
    { label: 'Amount Due', value: currencyFormatter.format(current.amount_due || 0) },
    { label: 'MRR at Risk', value: currencyFormatter.format(current.mrr_at_risk || 0) },
    { label: 'Still Retrying', value: (current.still_retrying || 0).toLocaleString() },
  ],

  renderCellValue: renderMemberCell(['failing_since', 'last_paid_at']),
};

function ReportingMembershipsFailedPaymentsPage(props) {
  return <SalesDetailPage {...props} config={FAILED_PAYMENTS_CONFIG} />;
}

export default ReportingMembershipsFailedPaymentsPage;
